import { RootState } from 'src/store';
import { LanguageState } from './language.types';

export const languageSelector = (state: RootState): LanguageState => state.language;
